import { useEffect, useRef, useState } from 'react';
import { mediaDisplaySource, refreshMediaSource } from '../shared/mediaSource';

export default function MediaImage({ src, size = 'card', onError, alt, ...props }) {
  const chosen = size === 'display' ? mediaDisplaySource(src) : src;
  const [current, setCurrent] = useState(chosen);
  const attempted = useRef(false), mounted = useRef(true), version = useRef(0);
  useEffect(() => { version.current++; setCurrent(chosen); attempted.current = false; }, [chosen]);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const failed = async event => {
    if (!/^https:\/\//.test(chosen || '')) { onError?.(event); return; }
    if (attempted.current) { onError?.(event); return; }
    attempted.current = true;
    const requestedVersion = version.current;
    try {
      const renewed = await refreshMediaSource(chosen, size);
      if (mounted.current && version.current === requestedVersion && renewed && renewed !== current) { setCurrent(renewed); return; }
    } catch { /* Keep retry bounded and retain the existing caller's fallback. */ }
    if (mounted.current && version.current === requestedVersion) onError?.(event);
  };
  return <img {...props} alt={alt} src={current} onError={failed} />;
}
